import { useChatbot } from '../../../contexts/ChatbotContext';
import { useCustomTexts } from '../../../hooks/useCustomTexts';

export function TextCustomization() {
  const { chatbotPublicId } = useChatbot();
  const { title, subtitle, welcomeMessage, inputPlaceholder, errorMessage, setTexts } = useCustomTexts();

  const handleTextChange = (key: string, value: string) => {
    if (chatbotPublicId) {
      setTexts({ [key]: value }, chatbotPublicId);
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Chatbot title
        </label>
        <input
          type="text"
          value={title}
          onChange={(e) => handleTextChange('title', e.target.value)}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Chatbot subtitle
        </label>
        <input
          type="text"
          value={subtitle}
          onChange={(e) => handleTextChange('subtitle', e.target.value)}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Welcome message
        </label>
        <textarea
          rows={4}
          value={welcomeMessage}
          onChange={(e) => handleTextChange('welcomeMessage', e.target.value)}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Input field placeholder
        </label>
        <input
          type="text"
          value={inputPlaceholder}
          onChange={(e) => handleTextChange('inputPlaceholder', e.target.value)}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Error message
        </label>
        <textarea
          rows={3}
          value={errorMessage}
          onChange={(e) => handleTextChange('errorMessage', e.target.value)}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder="Message displayed when an error occurs or conversation limits are reached"
        />
        <p className="mt-1 text-xs text-gray-500">
          This message will be shown when the AI response fails or when the maximum conversation limit is reached.
        </p>
      </div>
    </div>
  );
}